import { withDependencyWrites } from './write-intents';
import type { PortWithWrites } from '../../port-contract';
import { statusId } from './catalog';
import * as php from '../../php-compat';
import { call, r, type Ref, type DispatchEnv } from './dispatch';
/** PHP: apply_dying_stacks_to_target (includes/functions/janus/encounter/apply_dying_stacks_to_target.php:37) */
export function applyDyingStacksToTarget(target: Ref, roll: unknown, attack: unknown, affected: Ref, env: DispatchEnv): PortWithWrites<null> {
 return withDependencyWrites(env, env => {
    statusId(env,'dying_state_1');
    statusId(env,'dying_state_2');
    const unconscious = statusId(env,'unconscious');
    let recovery = 0, dying = 0;
    if (php.truthy(env.deps.has_status_effect(target.value, statusId(env,'recovery_state_2')))) recovery = 2;
    else if (php.truthy(env.deps.has_status_effect(target.value, statusId(env,'recovery_state_1')))) recovery = 1;
    if (php.truthy(env.deps.has_status_effect(target.value, statusId(env,'dying_state_2')))) dying = 2;
    else if (php.truthy(env.deps.has_status_effect(target.value, statusId(env,'dying_state_1')))) dying = 1;
    const stacks = php.equal(env.deps.layer_value(attack, 'critical_hit') ?? 0, 1) ? 2 : 1;
    dying += stacks;
    if (dying >= 3) {
        call(env, 'drop_target_equipped_in_hand_inventory', { target_arr: r(target), affected_ids: r(affected), roll_id: roll });
        call(env, 'remove_recovery_and_dying_states', { target_arr: r(target), affected_ids: r(affected) });
        call(env, 'insert_log_message', { roll_id: roll, roll_type_1: 'dies', roll_item_id: '', item_id_used_arr: '', roll_by_arr: r(target), roll_to_arr: '' });
        call(env, 'kill_creature', { encounter_creature_arr: r(target), affected_ids: r(affected) });
        return null;
    }
    if (dying === 1 || dying === 2) {
        if (recovery - dying < 0) {
            call(env, 'apply_status_effect', { status_connected_id: '', status_caster_arr: r(target), status_target_arr: r(target), status_casting_targets_arr: '', affected_ids: r(affected), status_origin_id: '', status_item_id: unconscious, status_ends: [], roll_id: roll, log_message: false });
            call(env, 'drop_target_equipped_in_hand_inventory', { target_arr: r(target), affected_ids: r(affected), roll_id: roll });
            call(env, 'insert_log_message', { roll_id: roll, roll_type_1: 'slipping_away', roll_item_id: '', item_id_used_arr: '', roll_by_arr: r(target), roll_to_arr: '' });
        }
        const status = statusId(env,stacks === 2 ? 'dying_state_2' : 'dying_state');
        call(env, 'apply_status_effect', { status_connected_id: '', status_caster_arr: r(target), status_target_arr: r(target), status_casting_targets_arr: '', affected_ids: r(affected), status_origin_id: '', status_item_id: status, status_ends: [], roll_id: roll });
    }
return null;

 });
}
